<template>
  <div>
    <div class="container cl de">
      <div class="row">
        <nav class="navbar-default">
          <div class="navbar-header">
            <button
              type="button"
              class="navbar-toggle collapsed"
              data-toggle="collapse"
              data-target="#bs-example-navbar-collapse-6"
              aria-expanded="false"
            >
              <span class="sr-only">Toggle navigation</span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
            </button>
            <router-link to="/" class="navbar-brand logo" tag="div">
              <img src="@/assets/images/logo.png" alt>
            </router-link>
          </div>

          <div
            class="navbar-collapse collapse"
            id="bs-example-navbar-collapse-6"
            aria-expanded="false"
            style="height: 1px;"
            
          >
            <ul class="nav navbar-nav">
              <li>
                <router-link to="/" exact >{{$t('nav[0].name')}}</router-link>
              </li>
              <li>
                <router-link to="/about">{{$t('nav[1].name')}}</router-link>
              </li>
              <li>
                <router-link to="/product">{{$t('nav[2].name')}}</router-link>
              </li>
              <li>
                <router-link to="/news">{{$t('nav[3].name')}}</router-link>
              </li>
              <li>
                <router-link to="/contact">{{$t('nav[4].name')}}</router-link>
              </li>
            </ul>

          

            <span v-on:click="changelang('cn')" class="z-btn">
              
              <router-link to="/"><img src="../assets/images/cn.png" alt></router-link> 
            </span>
            <span v-on:click="changelang('en')" class="z-btn">
              
              <router-link to="/"><img src="../assets/images/en.png" alt></router-link>

              
            </span>
          </div>
        </nav>
      </div>
    </div>
    <div class="banner">
      <swiper :options="swiperOption" ref="mySwiper">
        <!-- slides -->
        <swiper-slide v-for="(item,index) in banner" :key="index">
          <img :src="item.url" alt>
        </swiper-slide>
        <!-- <swiper-slide>
          <img src="@/assets/images/banner1.jpg" alt>
        </swiper-slide>-->
        <!-- Optional controls -->
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Header",
  data() {
    return {
      navs: [
        this.$t("nav[0]"),
        this.$t("nav[1]"),
        this.$t("nav[2]"),
        this.$t("nav[3]"),
        this.$t("nav[4]")
      ],
      banner: {},
      swiperOption: {
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
          stopOnLastSlide: false,
        },
        effect : 'fade',
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      }
    };
  },
  methods: {
    changelang(lang) {
      //this.$i18n.locale = lang;
      sessionStorage.setItem("locale", lang);
      
     // router.go(0)
     if (this.$route.path === '/') { // /date 表示日期选择路由
       location.reload(); // 列表页面的路由
     }
      //this.$router.push('/');
      
    }
  },
  mounted() {
    this.$http
      .get("http://www.hzjingbao.cn/api/banner", {
        params: {
          lang: this.$i18n.locale
        }
      })
      .then(res => {
        //console.log(res.data);
        this.banner = res.data;
        //console.log(this.banner)
      })
      .catch(erroe => {
        console.log(error);
      });
  }
 
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/header.vue